const React = require('react');
const {AdminSelect} = require('../../../../../../../../../dumb/FormInputs');

module.exports = ({id, name, list = [], formCtx}) => {
  const data = ((formCtx || {}).state || {}).data || {};
  const value = data[id];

  return (
    <div className="layoutRow aiC dB@m2">
    <span className="dB w136 mr15 pt10 pb18 f12 fw7 pb0@m2">
      {name}
    </span>
      <AdminSelect
        name={id}
        propValue="id"
        propName="name"
        items={list || []}
        formCtx={formCtx}
        disabled={!!value && list.length <= 1}
        disableLabel
      />
    </div>
  );
}
